// extracted by mini-css-extract-plugin
module.exports = {"Loader":"styles_Loader__2hizZ","lds-ripple":"styles_lds-ripple__1-evw"};